export const NIGHT_HOURS = [21, 22, 23];
